import React, { createContext, useContext, useEffect, useState } from "react";
import { PRODUCTS as MOCK } from "../mock/mock";

const ProductsContext = createContext(null);
const LS_KEY = "ardf_site_override_v1"; // preview overrides from editor

export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState(MOCK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      // 1) preview override (editor "Preview" mode)
      try {
        const raw = localStorage.getItem(LS_KEY);
        if (raw) {
          const site = JSON.parse(raw);
          if (site && Array.isArray(site.products) && site.products.length) {
            setProducts(site.products);
            setLoading(false);
            return;
          }
        }
      } catch (e) {}
      // 2) shipped data file
      try {
        const res = await fetch(`${process.env.PUBLIC_URL || ""}/data/site.json`, { cache: "no-store" });
        if (res.ok) {
          const site = await res.json();
          if (Array.isArray(site.products) && site.products.length) setProducts(site.products);
        }
      } catch (e) {}
      setLoading(false);
    };
    load();
  }, []);

  return (
    <ProductsContext.Provider value={{ products, loading, findById: (id) => products.find((p) => p.id === id) }}>
      {children}
    </ProductsContext.Provider>
  );
};

export const useProducts = () => {
  const ctx = useContext(ProductsContext);
  if (!ctx) throw new Error("useProducts must be used inside ProductsProvider");
  return ctx;
};
